import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
import { QueryParam_RedirectUrl } from '../session/index.js';
export const ApiDef_Account = {
    _v1: {
        registerAccount: { method: HttpMethod.POST, path: '/v1/account/register-account' },
        refreshSession: { method: HttpMethod.GET, path: '/v1/account/refresh-session' },
        createAccount: { method: HttpMethod.POST, path: '/v1/account/create-account' },
        changePassword: { method: HttpMethod.POST, path: '/v1/account/change-password' },
        login: { method: HttpMethod.POST, path: 'v1/account/login', timeout: Minute },
        logout: { method: HttpMethod.GET, path: 'v1/account/logout' },
        createToken: { method: HttpMethod.POST, path: 'v1/account/create-token', timeout: Minute },
        setPassword: { method: HttpMethod.POST, path: '/v1/account/set-password' },
        getSessions: { method: HttpMethod.GET, path: 'v1/account/get-sessions' },
        changeThumbnail: { method: HttpMethod.POST, path: '/v1/account/change-thumbnail' },
        getPasswordAssertionConfig: { method: HttpMethod.GET, path: '/v1/account/get-password-assertion-config' },
        deleteAccount: { method: HttpMethod.GET, path: '/v1/account/delete-account' },
    }
};
export const ApiDef_SAML = {
    _v1: {
        loginSaml: { method: HttpMethod.GET, path: 'v1/account/login-saml' },
        assertSAML: { method: HttpMethod.POST, path: 'v1/account/assert' }
    }
};
//# sourceMappingURL=api-def.js.map